<template>
  <button
    class="group relative bg-surface rounded-2xl shadow-xl hover:scale-105 hover:shadow-2xl overflow-hidden border border-text-primary/10"
    @click="$emit('click')"
  >
    <div class="absolute inset-0 bg-gradient-to-br from-primary/20 to-transparent"></div>
    <div
      class="card-icon w-12 h-12 mb-4 absolute"
      :class="{'top-6 left-6': !isMobileDevice, 'top-4 left-4': isMobileDevice}"
    >
      <component :is="icon" class="w-full h-full" :class="iconClass" />
    </div>
    <div class="relative z-10">
      <h2 class="text-2xl font-bold mb-2 text-text-primary">{{ title }}</h2>
      <p v-if="subtitle && !isMobileDevice" class="text-text-secondary">{{ subtitle }}</p>
    </div>
  </button>
</template>

<script setup lang="ts">
import { useDeviceDetection } from '@/composables/useDeviceDetection'
import type { FunctionalComponent } from 'vue'

withDefaults(defineProps<{
  icon: FunctionalComponent
  title: string
  subtitle?: string
  /** Tailwind class applied to the icon — defaults to text-text-tertiary. */
  iconClass?: string
}>(), {
  iconClass: 'text-text-tertiary',
})

defineEmits<{
  (e: 'click'): void
}>()

const { isMobileDevice } = useDeviceDetection()
</script>

<style scoped>
.card-icon {
  animation: card-icon-float 4s ease-in-out infinite;
}

@keyframes card-icon-float {
  0%, 100% { transform: translateY(0); }
  50%      { transform: translateY(-6px); }
}
</style>
